import { Col, Container, Row } from 'react-grid-system';
import IPasswordFormProps from './IPasswordFormProps';
import Tabs from './tabs/Tabs';
import { useState } from 'react';
import { TabValue } from '@fluentui/react-components';
import DetailsTab from './tabs/DetailsTab';
import AudienceTab from './tabs/AudienceTab';
import MFATab, { PersonalMessage } from './tabs/MFATab';
import AttributesTab from './tabs/AttributesTab';

const PasswordForm = (props: IPasswordFormProps) => {
  const [selectedTab, setSelectedTab] = useState<TabValue>("tab-details");
  const onTabChange = (tab: string) => setSelectedTab(tab);

  return (
    <Container fluid style={{ margin: 0, padding: 0 }}>
      <Row>
        <Col>
          <Tabs {...props} onTabChange={onTabChange} selectedTab={selectedTab} />
        </Col>
      </Row>
      <Row>
        <Col>
          <div style={{ margin: 0, maxWidth: "100%" }}>
              {selectedTab === "tab-details" && <DetailsTab {...props} />}
              {selectedTab === "tab-mfa" && <MFATab {...props} />}
              {
                selectedTab === "tab-audience" &&
                (
                  props.data.isPersonal
                    ? <PersonalMessage />
                    : <AudienceTab {...props} />
                )
              }
              {selectedTab === "tab-attributes" && <AttributesTab {...props} />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PasswordForm;